import React from 'react'
import * as constants from '../components/Constants'

export function IntroVideo(props) {
  
  // Disable ES-Lint error complaining about missing dependencies.
  // Intention is for this hook to be only executed on mounting the component for the first time.
  // I don't believe omitting the dependencies causes any problems (and adding them might cause problems).
  // Expectation is that updatePage function in props will never change.
  // Reference here: https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies  
  React.useEffect(() => {
      window.addEventListener('introVideoEnded', (event) => {

      props.updatePage(constants.REACT_PAGE_MAIN_ALIGN)
    })
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    </>
    
  )
}